<template>
<div class="crew-edit flex w-full justify-start" style="flex-direction: column;">

  <div ref="crewEditForm" style="height: calc(100vh - 210px); overflow-y: scroll; margin: 0 1rem;">

    <div class="flex w-full justify-start items-start crew-edit-form-row">
      <div class="flex w-full required"  style="flex-direction: column;">
        入力したメールアドレス宛に、アカウント招待メールを送信します。
      </div>
      <div class="flex w-full required mt-4 mb-4"  style="flex-direction: column;">
        <vs-input
          placeholder="メールアドレスを入力"
          class="w-full"
          label="メールアドレス(ID)"
          v-model="localData.email_address"
          v-validate="'required|email'"
          name="email_address"
          data-vv-as="メールアドレス(ID)"
          :color="AISEA_COLOR.BLUE"
        />
        <span class="text-danger text-sm" style="margin-left: 0.6rem;" v-show="errors.has('email_address')">{{
          errors.first("email_address")
        }}</span>
      </div>
      <div class="ml-2 mt-6 mr-0" >
        <div class="aisea-text-14-400-dark-gray"  style="flex-direction: column;">
          <div> * 入力したメールアドレスが、ログインに必要となるユーザーIDになります。</div>
          <div> * 招待期限は、メール送信後３日以内です。</div>
          <div> * 招待期限を超えた場合、再度招待してください。</div>
        </div>
      </div>
    </div>
  </div>


  <vs-divider style="margin: 0;" />

  <div class="flex w-full justify-between items-center">
    <div class="w-1/3 flex justify-start items-center">
    </div>
    <div  class="w-2/3 flex justify-end items-center">
      <div style="margin: 0.8rem;" >
        <vs-button type="flat" style="width: 6rem; padding: 0.4rem;" :style="{ 'background-color': AISEA_COLOR.WHITE, }"  @click="onCancel"  :color="AISEA_COLOR.GRAY" >キャンセル</vs-button>
      </div>    
      <div style="margin: 0.8rem;" >
        <vs-button style="width: 6rem; padding: 0.4rem;" @click="onSubmit" :disabled="!validateForm" :color="AISEA_COLOR.BLUE" >送信</vs-button>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountApi = AiseaApiFactory.get("enterpriseAdminAccount");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";



export default {
  name: "CrewEdit",
  components: {
  },
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      localData: {
      },
      continueFlg: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.localData.email_address;
    }
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
  },
  methods: {

    initLocalData() {
      this.continueFlg = this.inputParam.continueFlg;
      if ( this.inputParam.profile ) {
        this.localData.email_address = this.inputParam.profile.email_address;
      }
    },

    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    async onSubmit() {

      let checkValidate = await this.$validator.validateAll();
      if ( !checkValidate ) {
        return false;
      }

      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const res = await enterpriseAdminAccountApi.invites({
          "email_address": this.localData.email_address,
        });
        this.$vs.loading.close();

        if ( res.status ) {
          this.$vs.notify({
            title: `陸上従業員新規登録`,
            text: `登録したメールアドレスに、アカウント招待メールを送信しました。`,
            color: "success",
            icon: "done"
          });
        } else {
          this.$vs.notify({
            title: `陸上従業員新規登録`,
            text: `登録したメールアドレスに、アカウント招待メールを送信できませんでした。`,
            color: "warning",
            icon: "done"
          });
        }
      } catch (e) {
        this.$vs.notify({
          title: `陸上従業員新規登録`,
          text: `登録したメールアドレスに、アカウント招待メールを送信できませんでした。`,
          color: "warning",
          icon: "done"
        });
      }

      this.localData = {};

      this.$nextTick(() => {
        this.$emit('reloadList');
        this.$emit('close', this.continueFlg);
      });
    },
  },
  created() {
    this.initLocalData();
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.crew-edit {

  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger),1);
    }
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select input {
    height: 2.0rem;
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 1rem 0;
    padding-right : 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
}
</style>
